var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Copy_Icon",
    "data-name": "Copy Icon",
    d: "M9550.422,7145.4H9544.3a3.9,3.9,0,0,1-3.9-3.9v-6.124a3.9,3.9,0,0,1,3.9-3.9h.182v-.184a3.9,3.9,0,0,1,3.9-3.9h6.123a3.9,3.9,0,0,1,3.9,3.9v6.124a3.9,3.9,0,0,1-3.9,3.9h-.182v.185A3.9,3.9,0,0,1,9550.422,7145.4Zm-6.123-12.245a2.225,2.225,0,0,0-2.224,2.223v6.124a2.225,2.225,0,0,0,2.224,2.223h6.123a2.225,2.225,0,0,0,2.224-2.223v-6.124a2.225,2.225,0,0,0-2.224-2.223Zm6.123-1.674a3.9,3.9,0,0,1,3.9,3.9v4.266h.182a2.225,2.225,0,0,0,2.224-2.223V7131.3a2.227,2.227,0,0,0-2.224-2.225h-6.123a2.227,2.227,0,0,0-2.225,2.225v.184Z",
    transform: "translate(-9540.4 -7127.401)",
    fill: "#fff",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.498eb74e98eb1bfea9988f2d40b8fec0.svg";
export { ForwardRef as ReactComponent };